export enum OperatorFeedbackKeys {
    Score = "Score",
    Message = "Message"
}

export type OperatorFeedbackValues = {
    [OperatorFeedbackKeys.Score]: number
    [OperatorFeedbackKeys.Message]: string
}
